const TENANT_CODE_HEADER_KEY = 'DIGICLUE-TENANT-CODE';
const LIFF_ID_TOKEN_HEADER_KEY = 'DIGICLUE-TOKEN-ID';

/**
 * テナントごとの情報を取得するためのAPI実行用Header情報を生成する
 * @param tenantCode - 対象テナントコード
 * @returns APIリクエスト用のヘッダー情報
 */
export const generateTenantApiHeader = (
  tenantCode: string
): Record<string, string> => {
  return {
    'Content-Type': 'application/json',
    [TENANT_CODE_HEADER_KEY]: tenantCode
  };
};

/**
 * ユーザーごとの情報を取得するためのAPI実行用Header情報を生成する
 * @param tenantCode - 対象テナントコード
 * @param idToken - LiffのIdToken
 * @returns APIリクエスト用のヘッダー情報
 */
export const generateLiffIdTokenApiHeader = (
  tenantCode: string,
  idToken: string
): Record<string, string> => {
  return {
    ...generateTenantApiHeader(tenantCode),
    [LIFF_ID_TOKEN_HEADER_KEY]: idToken
  };
};
